import IAppLogger from '@app/lib/IAppLogger';
import { WebphoneCallEvent } from '../types';
import ToastModule from '@modules/ToastModule';
import strings from '../constants/strings';

const handleWebphoneCallEnded = (
  callEndedEvent: WebphoneCallEvent,
  logger: IAppLogger,
) => {
  if (
    callEndedEvent.cause === 'Terminated' &&
    callEndedEvent.originator === 'remote' &&
    callEndedEvent.sipResponse?.reasonPhrase === 'NORMAL_CLEARING'
  ) {
    logger.info(
      `Call ended by remote party. Call ID: ${callEndedEvent.callId}, Phone Number: ${callEndedEvent.phoneNumber}`,
    );
    ToastModule.showToast({
      title: strings.toasts.callEndedByRemoteParty,
      status: 'info',
      id: `call-ended${callEndedEvent.callId}`,
    });
  }
};

export default handleWebphoneCallEnded;
